var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-dropdown",
    { attrs: { trigger: ["click"] } },
    [
      _c(
        "div",
        { staticClass: "j-vxe-ds-icons" },
        [
          _c("a-icon", { attrs: { type: "align-left" } }),
          _c("a-icon", { attrs: { type: "align-right" } })
        ],
        1
      ),
      _c(
        "a-menu",
        { attrs: { slot: "overlay" }, slot: "overlay" },
        [
          _c(
            "a-menu-item",
            {
              key: "0",
              attrs: { disabled: _vm.disabledMoveUp },
              on: { click: _vm.handleRowMoveUp }
            },
            [_vm._v(_vm._s(_vm.language["common.moveUp"]))]
          ),
          _c(
            "a-menu-item",
            {
              key: "1",
              attrs: { disabled: _vm.disabledMoveDown },
              on: { click: _vm.handleRowMoveDown }
            },
            [_vm._v(_vm._s(_vm.language["common.moveDown"]))]
          ),
          _c("a-menu-divider"),
          _c(
            "a-menu-item",
            { key: "3", on: { click: _vm.handleRowInsertDown } },
            [_vm._v(_vm._s(_vm.language["common.addOneLine"]))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }